import { useFormatMenuItem } from "hooks/useFormatMenuItem";
import { Overlay, useTitle } from "modules/common";

export const SemisAdministration = () => {
    useTitle("Administracija PG-ova - eSavjetnik");
    const formatMenuItem = useFormatMenuItem("pg_administration");

    return (
        <Overlay
            containerClass={formatMenuItem}
            selectFirstMenuItemWhenAvailable
            titleBarProps={{ text: "Administracija PG-ova" }}
            fullScreenInitially={true}
            view={{
                title: "Administracija PG-ova",
                source: "https://semis.mps.hr/yiisemis/index.php?r=apprrrPgList/admin",
            }}
        />
    );
};

export default SemisAdministration;
